<template>
  <main-breadcrumb
    :items="items"
    showBackButton
  ></main-breadcrumb>
  <main-buttons-bar :align="'space-between'">
    <template #left>
      <custom-title>Edición de Cliente/prospecto</custom-title>
    </template>
  </main-buttons-bar>
  <detail-container>
    <el-form
      ref="formRef"
      :model="prospect"
      :rules="formRules"
      size="default"
    >
      <el-row :gutter="20">
        <el-form-item prop="Codigo">
          <custom-input
            v-model="prospect.Codigo"
            :label="'Código'"
            :spanColumn="24"
            :settings="{
              placeholder: 'Código',
              disabled: true,
            }"
          ></custom-input>
        </el-form-item>
        <el-form-item prop="CodigoSecundario">
          <custom-input
            v-model="prospect.CodigoSecundario"
            :label="'Código Adicional'"
            :spanColumn="24"
            :settings="{
              placeholder: 'Código Adicional',
            }"
          ></custom-input>
        </el-form-item>
        <el-form-item prop="CodigoEquivalente">
          <custom-input
            v-model="prospect.CodigoEquivalente"
            :label="'Código equivalente'"
            :settings="{
              placeholder: 'Ingresar código equivalente',
            }"
          />
        </el-form-item>
        <el-col :span="1"></el-col>
        <el-col :span="4">
          <div class="custom-label">Activo</div>
          <el-switch
            v-model="prospect.Activo"
            active-text="Si"
            inactive-text="No"
            class="mb-2"
            sieze="large"
          />
        </el-col>
        <custom-data
          :label="'Fecha creación'"
          :spanColumn="4"
          :data="prospect.FechaCreacion ? getDate('dd/mm/yyyy', prospect.FechaCreacion) : ''"
        ></custom-data>
      </el-row>
      <el-row
        :gutter="24"
        class="input-margin"
      >
        <el-form-item
          prop="Descripcion"
          class="full-width"
        >
          <custom-input
            v-model="prospect.Descripcion"
            :label="'Cliente/Prospecto'"
            :spanColumn="14"
            :settings="{
              placeholder: 'Ingresar el cliente',
              maxlength: 125,
              showWordLimit: true,
            }"
          ></custom-input>
        </el-form-item>
      </el-row>
      <el-row :gutter="20">
        <el-form-item prop="Giro">
          <custom-input
            v-model="prospect.Giro"
            :label="'Giro'"
            :spanColumn="24"
            :settings="{
              placeholder: 'Giro',
            }"
          ></custom-input>
        </el-form-item>
        <el-form-item prop="Utilidad">
          <custom-input-number
            v-model="prospect.Utilidad"
            :label="'Utilidad'"
            :spanColumn="24"
            :settings="{
              placeholder: 'Utilidad',
              max: 99.9,
              min: 0,
              controls: false,
              precision: 1,
            }"
          ></custom-input-number>
        </el-form-item>
      </el-row>
      <el-row
        :gutter="24"
        class="input-margin"
      >
        <el-col :span="8">
          <el-form-item
            prop="CodigoVendedorPrincipal"
            class="full-width"
          >
            <custom-ejecutivo-filter
              v-model="prospect.CodigoVendedorPrincipal"
              :spanColumn="24"
              label="Vendedor principal"
              :settings="{
                placeholder: 'Seleccionar un vendedor',
                size: 'default',
                isProspect: true,
              }"
              :prefillUser="prospect.UsuarioVendedorPrincipal"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            prop="CodigoVendedorSecundario"
            class="full-width"
          >
            <custom-ejecutivo-filter
              v-model="prospect.CodigoVendedorSecundario"
              :spanColumn="24"
              label="Vendedor secundario"
              :settings="{
                placeholder: 'Seleccionar un vendedor',
                size: 'default',
                isProspect: true,
              }"
              :prefillUser="prospect.UsuarioVendedorSecundario"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            prop="Clasificacion"
            class="full-width"
          >
            <custom-select
              v-model="prospect.Clasificacion"
              :spanColumn="24"
              label="Clasificación"
              :settings="{
                placeholder: 'Seleccionar clasificación',
                inputClass: 'custom_select',
                options: clasificaciones,
              }"
              @update:modelValue="handleClasificacionChange($event)"
            ></custom-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            prop="CodigoCondicionFiscal"
            class="full-width"
          >
            <custom-select
              v-model="prospect.CondicionFiscal"
              :spanColumn="24"
              label="Condición fiscal"
              :settings="{
                placeholder: 'Seleccionar condición fiscal',
                inputClass: 'custom_select',
                options: condicionesFiscales,
              }"
              @update:modelValue="handleCondicionFiscalChange($event)"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <div class="input-margin">
        <InputContactos
          v-model="prospect.Contactos"
          prop-prefix="Contactos"
        />
      </div>

      <div>
        <CustomLugaresEntregas
          v-model="prospect.LugaresEntrega"
          prop-prefix="LugaresEntrega"
        ></CustomLugaresEntregas>
      </div>
      <div class="container">
        <custom-confirm-buttons
          :showLoading="isSaving"
          :confirmText="'Guardar'"
          :cancelText="'Cancelar'"
          @on-cancel="onCancel"
          @on-confirm="onConfirm"
        ></custom-confirm-buttons>
      </div>
    </el-form>
  </detail-container>
</template>

<script setup>
import {
  onBeforeMount,
  ref,
  reactive,
  watch,
} from 'vue';
import { useProspectStore } from '../stores/prospect_store.js';
import { useCondicionFiscalStore } from '@/stores/condicion_fiscal_store.js';
import { storeToRefs } from 'pinia';
import {
  useRoute,
  useRouter,
} from 'vue-router';
import MainBreadcrumb from '@/shared/layout/main/main_breadcrum.vue';
import MainButtonsBar from '@/shared/layout/main/buttons_bar/main_buttons_bar.vue';
import DetailContainer from '@/shared/layout/detail/detail_container.vue';
import InputContactos from '@/shared/components/input_contactos.vue';
import CustomTitle from '@/shared/components/custom_title.vue';
import CustomInput from '@/shared/components/custom_input.vue';
import CustomInputNumber from '@/shared/components/custom_input_number.vue';
import CustomData from '@/shared/components/custom_data.vue';
import CustomEjecutivoFilter from '@/shared/components/custom_ejecutivo_filter.vue';
import CustomSelect from '@/shared/components/custom_select.vue';
import CustomLugaresEntregas from '@/shared/components/custom_lugares_entregas.vue';
import CustomConfirmButtons from '@/shared/components/custom_confirm_buttons.vue';
import getDate from '@/shared/components/utils.js';
import { useMessageError } from '@/shared/composables/message_error.js';
import { useMessageSuccess } from '@/shared/composables/message_success.js';
import { useLoading } from '@/shared/composables/loading.js';
import { ElNotification } from 'element-plus';

const route = useRoute();
const router = useRouter();
const prospectStore = useProspectStore();

const { findProspectByCodigoHTTP, resetProspect, saveProspect } = prospectStore;
const { prospect } = storeToRefs(prospectStore);
const condicionFiscalStore = useCondicionFiscalStore();
const { findAllCondicionFiscalHTTP } = condicionFiscalStore;
const { condicionesFiscales } = storeToRefs(condicionFiscalStore);

const items = [
  { label: 'Inicio', to: '/page/prospects/list', replace: false },
  { label: 'Edición', to: null, replace: false },
];

const formRef = ref(null);
const isSaving = ref(false);

const formRules = reactive({
  Descripcion: [{ required: true, message: 'Ingresar cliente', trigger: 'blur' }],
  CodigoVendedorPrincipal: [
    { required: true, message: 'Seleccionar vendedor principal', trigger: 'change' },
  ],
});

watch(
  () => prospect.value.LugaresEntrega,
  (list) => {
    Object.keys(formRules)
      .filter((key) => key.startsWith('LugaresEntrega'))
      .forEach((key) => delete formRules[key]);

    list.forEach((_, i) => {
      formRules[`LugaresEntrega.${i}.Descripcion`] = [
        { required: true, message: 'Ingrese descripción', trigger: 'blur' },
      ];
      formRules[`LugaresEntrega.${i}.Provincia`] = [
        { required: true, message: 'Ingrese provincia', trigger: 'blur' },
      ];
      formRules[`LugaresEntrega.${i}.DireccionDetallada`] = [
        { required: true, message: 'Ingrese dirección detallada', trigger: 'blur' },
      ];
    });
  },
  { deep: true, immediate: true },
);

watch(
  () => prospect.value?.Contactos || [],
  (list) => {
    Object.keys(formRules)
      .filter((key) => key.startsWith('Contactos'))
      .forEach((key) => delete formRules[key]);
    list.forEach((c, i) => {
      formRules[`Contactos.${i}.Email`] = [
        { type: 'email', message: 'Email inválido', trigger: 'blur' },
      ];
      formRules[`Contactos.${i}.Nombre`] = [{ max: 80, message: 'Máx 80 car.', trigger: 'blur' }];
      formRules[`Contactos.${i}.Apellido`] = [{ max: 80, message: 'Máx 80 car.', trigger: 'blur' }];
      formRules[`Contactos.${i}.TelefonoPrincipal`] = [
        { max: 30, message: 'Máx 30 car.', trigger: 'blur' },
      ];
      formRules[`Contactos.${i}.TelefonoSecundario`] = [
        { max: 30, message: 'Máx 30 car.', trigger: 'blur' },
      ];
    });
  },
  { deep: true, immediate: true },
);

const clasificaciones = ref([
  { Codigo: 1, Descripcion: 'Cliente final' },
  { Codigo: 2, Descripcion: 'Distribuidor' },
  { Codigo: 3, Descripcion: 'Distribuidor alto volumen' },
]);

function handleClasificacionChange(clasificacion) {
  prospect.value.CodigoClasificacion = clasificacion.Codigo;
}

function handleCondicionFiscalChange(item) {
  prospect.value.CodigoCondicionFiscal = item?.Codigo ?? null;
}

function sanitizeContactos(list = []) {
  return (list || [])
    .map((c) => ({
      Codigo: c?.Codigo, // Preservar el Codigo para actualizar contactos existentes
      Nombre: c?.Nombre?.trim() || undefined,
      Apellido: c?.Apellido?.trim() || undefined,
      Email: c?.Email?.trim() || undefined,
      TelefonoPrincipal: c?.TelefonoPrincipal?.trim() || undefined,
      TelefonoSecundario: c?.TelefonoSecundario?.trim() || undefined,
    }))
    .filter(
      (c) => c.Nombre || c.Apellido || c.Email || c.TelefonoPrincipal || c.TelefonoSecundario,
    );
}

const onConfirm = async () => {
  formRef.value.validate(async (valid) => {
    if (valid) {
      isSaving.value = true;
      useLoading().openLoading();
      try {
        prospect.value.Contactos = sanitizeContactos(prospect.value.Contactos);
        await saveProspect();
        useMessageSuccess().open('Los datos se han actualizado correctamente.');
        const id = route.params.id;
        if (id && +id > 0) {
          await findProspectByCodigoHTTP(id);
        }
      } catch (err) {
        useMessageError().open('Ha ocurrido un error al intentar actualizar los datos.');
      } finally {
        useLoading().closeLoading();
        isSaving.value = false;
      }
    } else {
      ElNotification({
        title: 'Edición de prospecto',
        message: 'Por favor, revise los campos ingresados.',
        type: 'warning',
      });
    }
  });
};

const onCancel = () => {
  resetProspect();
  resetFormValidation();
  router.push('/page/prospects/list');
};

const resetFormValidation = () => {
  if (formRef.value) {
    formRef.value.resetFields();
  }
};

onBeforeMount(async () => {
  const id = route.params.id;
  await findAllCondicionFiscalHTTP();
  if (id && +id > 0) {
    await findProspectByCodigoHTTP(id);
  }
});
</script>

<style scoped>
.container {
  display: flex;
  justify-content: flex-end; /* Alinea todo el contenido al final del contenedor */
}

.custom-label {
  font-weight: 700;
  color: #111;
}
.input-margin {
  margin-top: 3%;
}
.full-width {
  width: 100%;
}

:deep(.el-form-item .el-input),
:deep(.el-form-item .el-select),
:deep(.el-form-item .el-select__wrapper) {
  width: 100%;
}
</style>
